import {
  Condition,
  ItemDiscountMeasureOption,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface ItemDiscountState {
  measureOption: ItemDiscountMeasureOption;
  value: number;
}

export const ITEM_DISCOUNT = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ItemDiscountState>>,
): ConditionType<ItemDiscountState, Condition.ItemDiscount> => ({
  name: "Item discount",
  description(state) {
    const measureWording =
      state.measureOption == ItemDiscountMeasureOption.PERCENT
        ? "%"
        : "in your currency";

    return `Item discounted by ${state.value} ${measureWording} or greater`;
  },
  Details(props: ConditionTypeDetailsProps<ItemDiscountState>) {
    return React.createElement(Details, props);
  },
  empty: { measureOption: ItemDiscountMeasureOption.PERCENT, value: 10 },
  fromModel(model: Condition.ItemDiscount) {
    return { measureOption: model.measureOption, value: model.value };
  },
  toModel(state) {
    return {
      type: Condition.ITEM_DISCOUNT,
      measureOption: state.measureOption,
      value: state.value,
    };
  },
  valid() {
    return true;
  },
});
